import i18next from 'i18next';
import React from 'react';

import { canEditAccountMapping } from '@selectors/actions/storeActions';

import { Button } from '@commons/utils/styledLibraryComponents';
import sortActionsList from '@commons/utils/sortActionsList';

export const getActions = (
  selectedAccounts,
  handleExport,
  confirmDissociation,
  openAssociationModal,
  authorizedActions,
) => {
  const actions = [
    {
      id: 'export-list',
      actionLabel: i18next.t(
        !selectedAccounts.length ? 'GENERAL.EXPORT_LIST' : 'GENERAL.EXPORT_SELECTION',
      ),
      actionIcon: () => '/images/inpulse/file-download-black-small.svg',
      handleAction: () => handleExport(selectedAccounts),
    },
    {
      id: 'delete',
      actionLabel: i18next.t('GENERAL.DELETE_ASSOCIATION', { count: selectedAccounts.length }),
      actionIcon: () => '/images/inpulse/delete-ip-black-small.svg',
      handleAction: () => {
        confirmDissociation(selectedAccounts);
      },
      isHidden: () => !selectedAccounts.length || !canEditAccountMapping(authorizedActions),
    },
    {
      id: 'action-associate',
      fixed: true,
      actionLabel: i18next.t('GENERAL.ASSOCIATE'),
      handleAction: () => openAssociationModal(),
      isHidden: () => !canEditAccountMapping(authorizedActions),
      render: () => (
        <Button
          handleClick={openAssociationModal}
          icon={'/images/inpulse/add-white-small.svg'}
          isDisabled={!canEditAccountMapping(authorizedActions)}
          label={i18next.t('GENERAL.ASSOCIATE')}
        />
      ),
    },
  ];

  return sortActionsList(actions);
};

export const getRowActions = (confirmDissociation, authorizedActions) => [
  {
    id: 'delete',
    actionLabel: () => i18next.t('GENERAL.DELETE_ASSOCIATION', { count: 1 }),
    actionIcon: () => '/images/inpulse/delete-ip-black-small.svg',
    isHidden: () => !canEditAccountMapping(authorizedActions),
    handleAction: (selectedAccount) => {
      confirmDissociation([selectedAccount]);
    },
  },
];
